import type { IntegrationItem } from '@/features/Setting/Integrations/types';

import { v1ApiClient } from '..';

const integrationService = {
  async fetchIntegrationInfo(
    workspaceAlias: string,
    isPublic?: boolean,
  ): Promise<IntegrationItem[]> {
    const url = isPublic
      ? `/workspaces/${workspaceAlias}/integrations/public`
      : `/workspaces/${workspaceAlias}/integrations`;
    const res = await v1ApiClient.get(url);
    return res.data;
  },
};

export default integrationService;
